import { makeAutoObservable } from "mobx";

class ReportingYearStore {
  // Reporting Boundary
  id = null;

  startYear = null;
  startMonth = null;
  endYear = null;
  endMonth = null;

  // Frameworks
  frameworkCodes = [];
  selectedFrameworkCodes = [];
  availableFrameworks = [];

  // Assigned organizations
  organizations = [];
  isAllOrganization = false;
  isCompanySelected = false;

  // Usage information
  usedOrganizations = [];
  usedFrameworks = [];

  isUsed = false;
  isUsedAllOrganization = false;

  reportingYears = [];

  loading = false;
  error = null;

  constructor() {
    makeAutoObservable(this);
  }

  setReportingYears(reportingYears = []) {
    this.reportingYears = reportingYears;
  }

  setAvailableFrameworks(frameworks = []) {
    this.availableFrameworks = frameworks;
  }

  setReportingYear(item) {
    if (!item) return;

    this.id = item._id;

    this.startYear = item.startYear;
    this.startMonth = item.startMonth;
    this.endYear = item.endYear;
    this.endMonth = item.endMonth;

    this.frameworkCodes = item.frameworkCodes ?? [];
    this.selectedFrameworkCodes = item.frameworkCodes ?? [];

    this.organizations = item.organizations ?? [];

    this.isAllOrganization = Boolean(item.isAllOrganization);
    this.isCompanySelected = Boolean(item.isCompanySelected);

    // Usage
    this.usedOrganizations = item.usedOrganizations ?? [];
    this.usedFrameworks = item.usedFrameworks ?? [];

    this.isUsed = Boolean(item.isUsed);
    this.isUsedAllOrganization = Boolean(item.isUsedAllOrganization);
  }

  setLoading(value) {
    this.loading = value;
  }

  reset() {
    this.id = null;

    this.startYear = null;
    this.startMonth = null;
    this.endYear = null;
    this.endMonth = null;

    this.frameworkCodes = [];
    this.selectedFrameworkCodes = [];

    this.organizations = [];

    this.isAllOrganization = false;
    this.isCompanySelected = false;

    this.usedOrganizations = [];
    this.usedFrameworks = [];

    this.isUsed = false;
    this.isUsedAllOrganization = false;

    this.availableFrameworks = [];
    this.reportingYears = [];

    this.error = null;
  }
}
export const reportingYearStore = new ReportingYearStore();
